import Glide from './glide.esm.js'

(() => {

  const glideEl = document.querySelector('.glide--hero-slider')
  const sectionId = glideEl.dataset.glideSlider

  const glide = new Glide(`.glide--slider-${sectionId}`, {
    type: 'carousel',
    focusAt: 'center',
    perView: 1,
    perTouch: 1,
    gap: '0px',
    autoplay: 5000,
    hoverpause: true,
    animationDuration: 1000,
    dragThreshold: false
  })

  glideEl.addEventListener('input', (event) => {
    glide.update({
      autoplay: (event.target.value != 0) ? event.target.value : false
    })
  })

  glide.mount()

})()